import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NAVIGATE_TO = 'navigateTo';

const useOutsideNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleNavigateTo = (event: CustomEvent<{ path: string }>) => {
      navigate(event.detail.path);
    };

    window.addEventListener(NAVIGATE_TO, handleNavigateTo as EventListener);

    return () => {
      window.removeEventListener(
        NAVIGATE_TO,
        handleNavigateTo as EventListener,
      );
    };
  }, [navigate]);
};

export { useOutsideNavigation };
